import React from 'react';
import Line from '@splunk/dashboard-visualizations/Line';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import TitleSpecifiedCode from '!!raw-loader!./examples/TitleSpecified';
import TitleNotVisibleCode from '!!raw-loader!./examples/TitleNotVisible';
import SeriesColorsCode from '!!raw-loader!./examples/SeriesColors';
import FieldColorsCode from '!!raw-loader!./examples/FieldColors';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';
import ForegroundColorCode from '!!raw-loader!./examples/ForegroundColor';
import FontColorCode from '!!raw-loader!./examples/FontColor';
import SplitSeriesCode from '!!raw-loader!./examples/SplitSeries';
import SplitSeriesIndependentCode from '!!raw-loader!./examples/SplitSeriesIndependent';
import FieldDashStyleCode from '!!raw-loader!./examples/FieldDashStyle';
import LineDashStyleCode from '!!raw-loader!./examples/LineDashStyle';
import LineWidthCode from '!!raw-loader!./examples/LineWidth';
import AxisYAbbreviationCode from '!!raw-loader!./examples/AxisYAbbreviation';
import AxisYScaleCode from '!!raw-loader!./examples/AxisYScale';
import AxisXLabelVisiblilityCode from '!!raw-loader!./examples/AxisXLabelVisiblility';
import AxisYLabelVisiblilityCode from '!!raw-loader!./examples/AxisYLabelVisiblility';
import AxisXMajorLabelVisiblilityCode from '!!raw-loader!./examples/AxisXMajorLabelVisiblility';
import AxisYMajorLabelVisiblilityCode from '!!raw-loader!./examples/AxisYMajorLabelVisiblility';
import MajorGridCode from '!!raw-loader!./examples/MajorGrid';
import MinorGridCode from '!!raw-loader!./examples/MinorGrid';
import LegendCode from '!!raw-loader!./examples/Legend';
import FieldShowListCode from '!!raw-loader!./examples/FieldShowList';
import DataLabelsCode from '!!raw-loader!./examples/DataLabels';
import LineMarkersCode from '!!raw-loader!./examples/LineMarkers';
import TicksCode from '!!raw-loader!./examples/Ticks';
import NullValueModeCode from '!!raw-loader!./examples/NullValueMode';
import LegendModeCode from '!!raw-loader!./examples/LegendMode';
import IncludeZeroCode from '!!raw-loader!./examples/IncludeZero';
import ExtendRangeCode from '!!raw-loader!./examples/ExtendRange';
import IntegerUnitsCode from '!!raw-loader!./examples/IntegerUnits';
import LegendStyleModeCode from '!!raw-loader!./examples/LegendStyleMode';
import ChartOverlayCode from '!!raw-loader!./examples/ChartOverlay';
import AnnotationExampleCode from '!!raw-loader!./examples/Annotation';
import AnnotationColorExampleCode from '!!raw-loader!./examples/AnnotationColor';
import MultiSeriesExplicitCode from '!!raw-loader!./examples/MultiSeriesExplicit';
import MultiSeriesDynamicCode from '!!raw-loader!./examples/MultiSeriesDynamic';
import MultiYAxesCode from '!!raw-loader!./examples/MultiYAxes';

import BasicExample from './examples/Basic';
import TitleSpecifiedExample from './examples/TitleSpecified';
import TitleNotVisibleExample from './examples/TitleNotVisible';
import SeriesColorsExample from './examples/SeriesColors';
import FieldColorsExample from './examples/FieldColors';
import BackgroundColorExample from './examples/BackgroundColor';
import ForegroundColorExample from './examples/ForegroundColor';
import FontColorExample from './examples/FontColor';
import SplitSeriesExample from './examples/SplitSeries';
import SplitSeriesIndependentExample from './examples/SplitSeriesIndependent';
import LineDashStyleExample from './examples/LineDashStyle';
import FieldDashStyleExample from './examples/FieldDashStyle';
import LineWidthExample from './examples/LineWidth';
import AxisYAbbreviationExample from './examples/AxisYAbbreviation';
import AxisYScaleExample from './examples/AxisYScale';
import IncludeZeroExample from './examples/IncludeZero';
import ExtendRangeExample from './examples/ExtendRange';
import IntegerUnitsExample from './examples/IntegerUnits';
import AxisXLabelVisiblilityExample from './examples/AxisXLabelVisiblility';
import AxisYLabelVisiblilityExample from './examples/AxisYLabelVisiblility';
import AxisXMajorLabelVisiblilityExample from './examples/AxisXMajorLabelVisiblility';
import AxisYMajorLabelVisiblilityExample from './examples/AxisYMajorLabelVisiblility';
import MajorGridExample from './examples/MajorGrid';
import MinorGridExample from './examples/MinorGrid';
import LegendExample from './examples/Legend';
import FieldShowListExample from './examples/FieldShowList';
import DataLabelsExample from './examples/DataLabels';
import LineMarkersExample from './examples/LineMarkers';
import TicksExample from './examples/Ticks';
import NullValueModeExample from './examples/NullValueMode';
import LegendModeExample from './examples/LegendMode';
import LegendStyleModeExample from './examples/LegendStyleMode';
import ChartOverlayExample from './examples/ChartOverlay';
import AnnotationExample from './examples/Annotation';
import AnnotationColorExample from './examples/AnnotationColor';
import MultiSeriesExplicitExample from './examples/MultiSeriesExplicit';
import MultiSeriesDynamicExample from './examples/MultiSeriesDynamic';
import MultiYAxesExample from './examples/MultiYAxes';
import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Line"
        examplesSection={[
            <DocExample title="Basic Line" key="basic" code={BasicExampleCode} example={BasicExample} />,
            <DocExample
                title="Annotation"
                key="annotation"
                code={AnnotationExampleCode}
                example={AnnotationExample}
            />,
            <DocExample
                title="Annotation Category Color"
                key="annotationcolor"
                code={AnnotationColorExampleCode}
                example={AnnotationColorExample}
            />,
            <DocExample
                title="Axis Y and X Title specified"
                key="titlespecified"
                code={TitleSpecifiedCode}
                example={TitleSpecifiedExample}
            />,
            <DocExample
                title="Axis Y and X Title not visible"
                key="titlenotvisible"
                code={TitleNotVisibleCode}
                example={TitleNotVisibleExample}
            />,
            <DocExample
                title="Series Color: Red and Blue"
                key="seriescolors"
                code={SeriesColorsCode}
                example={SeriesColorsExample}
            />,
            <DocExample
                title="Field colors: Total Count - Green, Percent - Orange"
                key="fieldcolors"
                code={FieldColorsCode}
                example={FieldColorsExample}
            />,
            <DocExample
                title="Background Color - Green"
                key="backgroundcolor"
                code={BackgroundColorCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Foreground Color - Red"
                key="foregroundcolor"
                code={ForegroundColorCode}
                example={ForegroundColorExample}
            />,
            <DocExample
                title="Font Color - Blue"
                key="fontcolor"
                code={FontColorCode}
                example={FontColorExample}
            />,
            <DocExample
                title="Split Series - True"
                key="splitseries"
                code={SplitSeriesCode}
                example={SplitSeriesExample}
            />,
            <DocExample
                title="Split Series and Split Series Independent - True"
                key="splitseriesindependent"
                code={SplitSeriesIndependentCode}
                example={SplitSeriesIndependentExample}
            />,
            <DocExample
                title="Line Dash Style - shortDashDot"
                key="linedashstyle"
                code={LineDashStyleCode}
                example={LineDashStyleExample}
            />,
            <DocExample
                title="Field Dash Style. Count - dash, Percent - dashDot"
                key="fielddashstyle"
                code={FieldDashStyleCode}
                example={FieldDashStyleExample}
            />,
            <DocExample
                title="Line Width - 5"
                key="linewidth"
                code={LineWidthCode}
                example={LineWidthExample}
            />,
            <DocExample
                title="Axis-Y Abbreviation - On"
                key="axisyabbreviation"
                code={AxisYAbbreviationCode}
                example={AxisYAbbreviationExample}
            />,
            <DocExample
                title="Axis-Y Scale - Log"
                key="axisyscale"
                code={AxisYScaleCode}
                example={AxisYScaleExample}
            />,
            <DocExample
                title="Axis-Y Include Zero - True"
                key="includezero"
                code={IncludeZeroCode}
                example={IncludeZeroExample}
            />,
            <DocExample
                title="Axis-Y Extend Axis Range - False"
                key="extendrange"
                code={ExtendRangeCode}
                example={ExtendRangeExample}
            />,
            <DocExample
                title="Axis-Y Integer Units - True"
                key="integerunits"
                code={IntegerUnitsCode}
                example={IntegerUnitsExample}
            />,
            <DocExample
                title="Axis-X - Show"
                key="axisxlabelvisiblility"
                code={AxisXLabelVisiblilityCode}
                example={AxisXLabelVisiblilityExample}
            />,
            <DocExample
                title="Axis-Y - Show"
                key="axisylabelvisiblility"
                code={AxisYLabelVisiblilityCode}
                example={AxisYLabelVisiblilityExample}
            />,
            <DocExample
                title="Axis-X Major Tick Labels - Hide"
                key="axisxmajorlabelvisiblility"
                code={AxisXMajorLabelVisiblilityCode}
                example={AxisXMajorLabelVisiblilityExample}
            />,
            <DocExample
                title="Axis-Y Major Tick Labels - Hide"
                key="axisymajorlabelvisiblility"
                code={AxisYMajorLabelVisiblilityCode}
                example={AxisYMajorLabelVisiblilityExample}
            />,
            <DocExample
                title="Axis-Y major grid - False, Axis-X major grid - True"
                key="majorgrid"
                code={MajorGridCode}
                example={MajorGridExample}
            />,
            <DocExample
                title="Axis-Y minor grid - True"
                key="minorgrid"
                code={MinorGridCode}
                example={MinorGridExample}
            />,
            <DocExample
                title="Axis-Y major, minor ticks - Show (15, 10), Axis-X - Hide"
                key="ticks"
                code={TicksCode}
                example={TicksExample}
            />,
            <DocExample
                title="Null Value Mode - Zero"
                key="nullvaluemode"
                code={NullValueModeCode}
                example={NullValueModeExample}
            />,
            <DocExample
                title="Legend Mode - Series Compare"
                key="legendmode"
                code={LegendModeCode}
                example={LegendModeExample}
            />,
            <DocExample
                title="Very Long Legend Labels, Legend Style Mode - End"
                key="legendstylemode"
                code={LegendStyleModeCode}
                example={LegendStyleModeExample}
            />,
            <DocExample
                title="New Legend Labels, Legend Labels - Top"
                key="legend"
                code={LegendCode}
                example={LegendExample}
            />,
            <DocExample
                title="Field Show List - Percent"
                key="fieldshowlist"
                code={FieldShowListCode}
                example={FieldShowListExample}
            />,
            <DocExample
                title="Data Labels - All"
                key="datalabels"
                code={DataLabelsCode}
                example={DataLabelsExample}
            />,
            <DocExample
                title="Show Markers - False"
                key="lineMarkers"
                code={LineMarkersCode}
                example={LineMarkersExample}
            />,
            <DocExample
                title="Chart Overlay - On, Axis-Y2 Title specified, Abbreviation - On"
                key="chartoverlay"
                code={ChartOverlayCode}
                example={ChartOverlayExample}
            />,
            <DocExample
                title="Multi Series - Explicit encoding"
                key="multiseriesexplicit"
                code={MultiSeriesExplicitCode}
                example={MultiSeriesExplicitExample}
            />,
            <DocExample
                title="Multi Series - Dynamic encoding"
                key="multiseriesdynamic"
                code={MultiSeriesDynamicCode}
                example={MultiSeriesDynamicExample}
            />,
            <DocExample
                title="Multi Y Axes"
                key="multiyaxes"
                code={MultiYAxesCode}
                example={MultiYAxesExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                events={doc.events}
                Visualization={Line}
                dsState={{
                    primary: {
                        requestParams: { offset: 0, count: 20 },
                        data: {
                            fields: [
                                { name: '_time', groupby_rank: '0' },
                                { name: 'count' },
                                { name: '_span' },
                            ],
                            columns: [
                                [
                                    '2018-05-02T18:15:46.000-07:00',
                                    '2018-05-02T18:15:47.000-07:00',
                                    '2018-05-02T18:15:48.000-07:00',
                                    '2018-05-02T18:15:49.000-07:00',
                                    '2018-05-02T18:15:50.000-07:00',
                                ],
                                ['2', '10', '13', '60', '43', '85'],
                                ['1', '1', '1', '1', '1', '1'],
                            ],
                        },
                        meta: { totalCount: 20 },
                    },
                }}
            />
        }
    />
);
